module.exports = __webpack_public_path__ + "media/images/agencies-placeholder-e568dfdc7997dfcf3c1ccd43d2231833.png";